import { useMemo } from "react";
import { SuggestionMenu } from "@/tiptap/ui-utils/suggestion-menu"
import {
  EmojiMenuItem,
  getFilteredEmojis,
} from "@/tiptap/ui/emoji-menu"
import {
  Card,
  CardBody,
  CardItemGroup,
} from "@/tiptap/ui-primitive/card"

export const EmojiDropdownMenu = (props) => {
  return (
    <SuggestionMenu
      char=":"
      pluginKey="emojiDropdownMenu"
      decorationClass="tiptap-emoji-decoration"
      selector="tiptap-emoji-dropdown-menu"
      items={getSuggestionItems}
      {...props}>
      {(props) => <EmojiList {...props} />}
    </SuggestionMenu>
  );
}

const getSuggestionItems = async (props) => {
  const emojis = props.editor.extensionStorage.emoji.emojis || []
  const filteredEmojis = getFilteredEmojis({ query: props.query, emojis })

  return filteredEmojis.map(emoji => ({
    title: emoji.name,
    subtext: emoji.shortcodes.join(", "),
    context: emoji,

    onSelect: (props) => {
      if (!props.editor || !props.range || !props.context) return
      props.editor.chain().focus().setEmoji(props.context.name).run()
    }
  }));
}

const EmojiList = ({
  items,
  selectedIndex,
  onSelect
}) => {
  const renderedItems = useMemo(() => {
    const rendered = []

    items.forEach((item, index) => {
      if (!item.context) return

      rendered.push(<EmojiMenuItem
        key={item.title}
        emoji={item.context}
        index={index}
        isSelected={index === selectedIndex}
        onSelect={() => onSelect(item)}
        selector="[data-selector='tiptap-emoji-dropdown-menu']" />)
    })

    return rendered
  }, [items, selectedIndex, onSelect])

  if (!renderedItems.length) {
    return null
  }

  return (
    <Card
      style={{
        maxHeight: "var(--suggestion-menu-max-height)",
      }}>
      <CardBody>
        <CardItemGroup>{renderedItems}</CardItemGroup>
      </CardBody>
    </Card>
  );
}
